import type { IconData } from '@stacksjs/iconify-core'

export const flag: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 1h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2v7a1 1 0 0 1-2 0V1a1 1 0 1 1 2 0m0 9h12V3H2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default flag
